/* Small live fixes that would otherwise mean rewriting a 119,000 character
   pricing template. When that template is next rebuilt properly, these move
   into the markup and this file goes away. */
(function () {
  function fix() {
    var face = document.getElementById('pfFaceManaged');
    if (!face) return;
    face.querySelectorAll('.pr-cta').forEach(function (el) {
      if (el.textContent.trim().toLowerCase() === 'get started') el.textContent = 'Buy now';
    });
    var starter = face.querySelector('.pr-card.t-starter .pr-cta');
    if (starter) starter.classList.add('pr-cta-starter');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  else fix();
  window.addEventListener('load', fix);
})();
